import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName } from 'recompose';
import { Trans } from 'lingui-react';
import { compact } from 'lodash';

import InlineEditableField from 'components/_common/InlineEditableField';
import Widget from 'elements/Widget';

import PdfLink from 'components/PdfLink';

import { formatDate } from 'utils/timeUtils';
import { getOutputText } from 'utils/widget';
import cardType from 'utils/cardType';

import messages from './messages';
import InvoiceInfo from './InvoiceInfo';

import withConnectedData from './Container';

export class EstimateInvoiceDecidedWidget extends Component {
  state = {
    poNumber: '',
    initialPoNumber: '',
  }

  componentWillMount() {
    if (!this.widgetShouldRender()) {
      const { configName, addHiddenWidget } = this.props;
      addHiddenWidget(configName);
    }
  }

  onChangePONumber = (e) => {
    this.setState({
      poNumber: e.target.value,
    });
  }

  onUpdatePONumber = (isSubmitting) => {
    if (!isSubmitting) {
      this.setState({
        poNumber: this.state.initialPoNumber,
      });
    }
  }

  setInitialPONumber = (value) => {
    this.setState({
      initialPoNumber: value,
    });
  }

  widgetShouldRender() {
    const { approvalStatus } = this.props.caseInfo;
    return approvalStatus !== 'Pending';
  }

  render() {
    const { caseInfo } = this.props;
    const {
      approvalStatus,
      etr,
      roUrl,
      roNumber,
      invoiceId,
      invoiceTotal,
      estimateTotal,
      approvalComment,
      invoiceDate,
    } = caseInfo;

    const formattedEtr = etr ? formatDate(etr) : getOutputText(etr);
    const poNumber = this.state.poNumber || caseInfo.poNumber || '';
    const invoiceDateStr = invoiceDate ?
      formatDate(invoiceDate) : getOutputText(invoiceDate);
    const isApprovedOrDeclined = approvalStatus === 'approved'
      || approvalStatus === 'declined';
    const approvalCommentModifier = roUrl && 'topGap';
    const statusCardType = cardType(approvalStatus);

    if (!this.widgetShouldRender()) {
      return null;
    }

    return (
      <Widget
        id="estimate-invoice"
        className="estimate-invoice-decided"
        expandKey="estimate-invoice"
      >
        <Widget.Header>
          <Trans id={messages.title} />
        </Widget.Header>
        <Widget.Item>
          <Widget.SubHeader modifiers={compact([statusCardType])}>
            {approvalStatus}
          </Widget.SubHeader>
        </Widget.Item>
        <Widget.Item horizontal>
          <Widget.Table>
            <tbody>
              <Widget.TableRow>
                <th>
                  <Trans id={messages.amount} />
                </th>
                <td>
                  {estimateTotal}
                </td>
              </Widget.TableRow>
              <Widget.TableRow modifiers={['topGap']}>
                <th>
                  <Trans id={messages.etr} />
                </th>
                <td>
                  {formattedEtr}
                </td>
              </Widget.TableRow>
              <Widget.TableRow modifiers={['topGap']}>
                <th>
                  <Trans id={messages.repairOrder} />
                </th>
                <td>
                  {roNumber && '#'}
                  {getOutputText(roNumber)}
                </td>
              </Widget.TableRow>
              <Widget.TableRow modifiers={['topGap']}>
                <th>
                  <Trans id={messages.po} />
                </th>
                {isApprovedOrDeclined ?
                  <td>
                    <InlineEditableField
                      value={poNumber}
                      onUpdate={this.onUpdatePONumber}
                      onChange={this.onChangePONumber}
                      getInitialValue={this.setInitialPONumber}
                    />
                  </td>
                  : <td>
                    {poNumber && '#'}
                    {getOutputText(poNumber)}
                  </td>
                }
              </Widget.TableRow>
              <Widget.TableRow modifiers={['topGap']}>
                <th>
                  <Trans id={messages.invoice} />
                </th>
                <td>
                  {invoiceId && '#'}
                  {getOutputText(invoiceId)}
                </td>
              </Widget.TableRow>
              <Widget.TableRow>
                <td />
                <td>
                  <InvoiceInfo estimateTotal={estimateTotal} invoiceTotal={invoiceTotal} />
                </td>
              </Widget.TableRow>
              <Widget.TableRow>
                <th />
                <td>
                  {invoiceDateStr}
                </td>
              </Widget.TableRow>
            </tbody>
          </Widget.Table>
          <Widget.Table>
            <tbody>
              <Widget.TableRow>
                <th>
                  {roUrl &&
                    <Trans id={messages.estimates} />
                  }
                </th>
                <td>
                  <PdfLink url={roUrl}>
                    <Trans id={messages.viewLatestEstimate} />
                  </PdfLink>
                </td>
              </Widget.TableRow>
              <Widget.TableRow modifiers={compact([approvalCommentModifier])}>
                <th>
                  {approvalComment &&
                    <Trans id={messages.comments} />
                  }
                </th>
                <td>
                  {approvalComment}
                </td>
              </Widget.TableRow>
            </tbody>
          </Widget.Table>
        </Widget.Item>
        <Widget.Item />
      </Widget>
    );
  }
}

EstimateInvoiceDecidedWidget.propTypes = {
  caseInfo: PropTypes.shape({
    approvalStatus: PropTypes.string,
    estimateTotal: PropTypes.string,
    invoiceId: PropTypes.string,
    invoiceTotal: PropTypes.string,
    roNumber: PropTypes.string,
    poNumber: PropTypes.string,
  }).isRequired,
  configName: PropTypes.string.isRequired,
  addHiddenWidget: PropTypes.func.isRequired,
};

export default compose(
  setDisplayName('EstimateInvoiceDecidedWidget'),
  withConnectedData,
)(EstimateInvoiceDecidedWidget);



// WEBPACK FOOTER //
// ./compositions/EstimateInvoiceDecidedWidget/index.js